import {
  IonAlert,
  IonButton,
  IonCheckbox,
  IonIcon,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTextarea,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Incrementer from '../../components/incrementer';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import { PillGroup } from '../../components/pill';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import {
  capitalize,
  deepCopy,
  forwardTo,
  getLocale,
  isDefined,
  isEmptyObject,
  isWebConfig,
  makeKey,
} from '../../lib/utils';
import { storeItemWeb } from '../../store/actions';
import './index.css';
import { ReactComponent as DiscountIcon } from '../../assets/images/discount.svg';
import { alertCircle } from 'ionicons/icons';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import { ReactComponent as AllergensIcon } from '../../assets/images/allergens.svg';

const {
  formatPrice,
  _calculateItemPrice,
  validateItem,
  addToBasket,
  getProductName,
  getProductDescription,
  isProductEnabled,
  isProductJustEnabled,
  isChoicesGroupValid,
  setAllergen,
} = Basket;

class itemDetailsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
      price: 0,
      selectedChoices: [],
      validationErrors: [],
      showValidationAlert: false,
      allergensCodes: [],
      specialInstructionsModalOpen: false,
      instructions: '',
      modalInstructions: '',
      upsellModalOpened: false
    };
  }

  componentDidMount() {
    const { profile, allergens, item } = this.props;
    let quantity = this.state.quantity;
    let selectedChoices = [];
    let validationErrors = [];

    if (item.menuDealGroups && item.menuDealGroups.length > 0) {
      selectedChoices = Array(item.menuDealGroups.length).fill([]);
      validationErrors = Array(item.menuDealGroups.length).fill(null);
    }
    let price = _calculateItemPrice({ item, quantity });
    let locale = getLocale(profile);
    if (locale === 'fr') {
      locale = 'fr_FR';
    }
    let allergensCodes = item ? (item.itemRichData ? ((item.itemRichData.allergenCodes && item.itemRichData.allergenCodes.length) > 0 ? item.itemRichData.allergenCodes : []) : []) : [];
    let newArr = [];

    allergensCodes.map((allergenCode) => {

      let dataArr = (allergens && allergens.data ? allergens.data : []).find((allergen) => {
        let dataArr2 = null;
        if (allergen.code === allergenCode) {
          dataArr2 = allergen.translations.find((data) => {
            if (data.locale === locale) {
              newArr.push(data.text);
              return data;
            }
            return null;
          });
        }
        return dataArr2;
      });
      if (!dataArr) {
        newArr.push(allergenCode);
      }
      return null;
    });
    this.props.handleAlergens(newArr)
    this.setState({ price, selectedChoices, validationErrors, allergensCodes: newArr }, () => {
      const initialValidationErrors = validateItem(this.constructBasketItem());
      this.setState({ validationErrors: initialValidationErrors.errors });
    });
  }

  onIncrementerUpdate = (newQuantity) => {
    this.setState({
      quantity: newQuantity,
      price: _calculateItemPrice({
        item: this.props.item,
        quantity: newQuantity,
        selectedChoices: this.state.selectedChoices,
      }),
    });
  };

  updateSelectedChoices = (
    groupIndex,
    choiceIndex,
    multiSelectionPermitted,
    selected = true,
    quantity = 0,
  ) => {
    // const item = this.props.location.state
    const { item } = this.props;
    const { selectedChoices } = this.state;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[choiceIndex]
        ? deepCopy(selectedGroup.items[choiceIndex])
        : {};
      let updatedSelectedChoices = deepCopy(selectedChoices);
      let selectedChoiceIndex = -1;
      const existingChoice = updatedSelectedChoices[groupIndex].find((i, index) => {
        if (selectedChoice && i.sku === selectedChoice.sku) {
          selectedChoiceIndex = index;
          return true;
        }
        return false;
      });
      if (multiSelectionPermitted) {
        //checkbox
        if (selected) {
          selectedChoice.quantity = 1;
          if (existingChoice) {
            existingChoice.quantity = quantity;
            if (
              selectedChoiceIndex !== -1 &&
              updatedSelectedChoices[groupIndex] &&
              updatedSelectedChoices[groupIndex][selectedChoiceIndex]
            ) {
              updatedSelectedChoices[groupIndex][selectedChoiceIndex] = existingChoice;
            }
          } else {
            updatedSelectedChoices[groupIndex].push(selectedChoice);
          }
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedChoices[groupIndex] = updatedSelectedChoices[groupIndex].filter(
            (i) => i.sku !== selectedChoice.sku,
          );
        }
      } else {
        if (selected) {
          selectedChoice.quantity = quantity;
          updatedSelectedChoices[groupIndex] = [selectedChoice];
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedChoices[groupIndex] = [];
        }
      }

      this.setState({ selectedChoices: updatedSelectedChoices }, () => {
        const { selectedChoices } = this.state;
        const newCalculatedPrice = _calculateItemPrice({
          item,
          quantity: this.state.quantity,
          selectedChoices,
        });
        this.setState(
          {
            price: _calculateItemPrice({
              item,
              quantity: this.state.quantity,
              selectedChoices,
            }),
          },
          () => {
            if (this.props.priceUpdated) {
              this.props.priceUpdated(newCalculatedPrice);
            }
            const validationErrors = validateItem(this.constructBasketItem());
            this.setState({ validationErrors: validationErrors.errors });
          },
        );
      });
    }
  };
  instructionsChange = (event) => this.setState({ modalInstructions: event.target.value });

  handleInputChange = (groupIndex, choiceIndex, multiSelectionPermitted, event) => {
    const item = this.props.item;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[choiceIndex];
      this.updateSelectedChoices(
        groupIndex,
        choiceIndex,
        multiSelectionPermitted,
        multiSelectionPermitted ? event.target.checked : !!selectedChoice,
        selectedChoice ? 1 : 0,
      );
    }
  };

  onIncrementerChoiceUpdate = (newQuantity, data) => {
    const { item } = this.props;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[data.groupIndex];
    if (selectedGroup) {
      this.updateSelectedChoices(
        data.groupIndex,
        data.choiceIndex,
        data.multiSelectionPermitted,
        newQuantity > 0,
        newQuantity,
      );
    }
  };
  drawGroupChoices = (menuGroupItem, multiSelectionPermitted, groupIndex) => {
    const { items, max, multiMax } = menuGroupItem;
    const choices = items || [];
    const { selectedChoices } = this.state;
    const { profile, __ } = this.props;
    const allChoices = choices.map((item, choiceIndex) => {
      const { sku, productPrice } = item;
      const isChecked = !!(selectedChoices[groupIndex] || []).find((i) => {
        return i.sku === sku;
      });
      if (
        item.sku === undefined ||
        (getConfig().flags.showSnoozedProducts
          ? !isProductJustEnabled(item)
          : !isProductEnabled(item))
      ) {
        return <span key={item.sku + '_disabled'} />;
      }
      const groupQuantity =
        selectedChoices[groupIndex] && selectedChoices[groupIndex].length > 0
          ? selectedChoices[groupIndex].reduce((sum, i) => sum + i.quantity || 0, 0)
          : 0;
      let quantity = 0;
      if (selectedChoices[groupIndex]) {
        const _choice = selectedChoices[groupIndex].find((i) => i.sku === sku);
        quantity = _choice ? _choice.quantity : 0;
      }
      let groupQunatity = 0;
      (selectedChoices[groupIndex] || []).forEach((i) => {
        groupQunatity += isDefined(i.quantity) ? i.quantity : 1;
      });
      const shouldBeDisabled =
        isDefined(max) &&
        max > 0 &&
        isDefined(selectedChoices[groupIndex]) &&
        groupQunatity >= max &&
        !isChecked;
      /* eslint-disable */
      const allergensCodes = item?.itemRichData?.allergenCodes || [];
      let locale = getLocale(profile);
      let allergensData = [];
      if (allergensCodes.length > 0) {
        allergensData = allergensCodes.map((allergen) => {
          const allergenData = this.props?.allergens?.data?.find((el) => el.code == allergen);
          const translation = allergenData?.translations && allergenData?.translations?.find((translation) => translation.locale == locale);
          if (translation) {
            return translation.text;
          } else {
            return allergen;
          }
        });
      }
      if (menuGroupItem.hasOwnProperty('multiMax')) {
        /* eslint-enable */
        return (
          <div
            className={`sub-item ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
            key={makeKey(choiceIndex, sku, groupIndex)}
          >
            <IonItem lines="none">
              <div >
                {Basket.isProductUnsnoozed(item) ? (
                  <>
                    {multiSelectionPermitted ? (
                      <IonCheckbox
                        labelPlacement="end"
                        disabled={shouldBeDisabled}
                        className="details"
                        color='primary'
                        slot="start"
                        checked={isChecked}
                        onIonChange={(event) => {
                          this.handleInputChange(
                            groupIndex,
                            choiceIndex,
                            multiSelectionPermitted,
                            event,
                          );
                        }}
                      >
                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              <Spacer size={0} />

                              {formatPrice(productPrice) ? <NormalText>+{formatPrice(productPrice)}</NormalText> : null}

                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                          </div>
                        }

                      </IonCheckbox>

                    ) : (
                      <IonRadio
                        labelPlacement="end"
                        slot="start"
                        className={'details' + (isChecked ? ' primary-radio' : '')}
                        color={'primary'}
                        value={choiceIndex}
                        checked={isChecked}

                      >
                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              <Spacer size={0} />

                              {formatPrice(productPrice) ? <NormalText>+{formatPrice(productPrice)}</NormalText> : null}

                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                          </div>
                        }

                      </IonRadio>
                    )}
                  </>
                ) : (
                  <div className="checkbox-placeholder"></div>
                )}
                {isWebConfig()

                  ?
                  <div className='sub-item-content'>
                    {(getConfig().flags.showModifierImage) &&
                      <div className='modifier-image'>
                        {item?.itemRichData?.squareImageUrl ?
                          <img src={item?.itemRichData?.squareImageUrl.replace(/http:\/\//g, 'https://')} />
                          :
                          <img src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                        }
                      </div>
                    }
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                        <StrongText>{__(getProductName(item, profile))}</StrongText>
                        {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                      </div>
                      {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                        <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                      }

                      {allergensData && allergensData.length > 0 ? (
                        <SmallText className='primary-color'>
                          {allergensData.map(el => capitalize(el)).join(', ')}
                        </SmallText>
                      ) : null}

                      <div className="price-increment-content">

                        {quantity >= 1 && max > 1 && multiMax > 1 ? (
                          <div
                            className={formatPrice(productPrice) ? 'incrementer-box' : 'incrementer-box-top'}
                          >
                            <Incrementer
                              {...(isWebConfig() && { allowInput: true })}
                              allowNegative={false}
                              data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                              disabled={shouldBeDisabled}
                              maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                              onUpdate={this.onIncrementerChoiceUpdate}
                              quantity={quantity || 0}
                            />
                          </div>
                        ) : <div></div>}

                      </div>
                    </div>
                  </div> :
                  <div className="price-increment-content">
                    {quantity >= 1 && max > 1 && multiMax > 1 ? (
                      <div
                        className={formatPrice(productPrice) ? 'incrementer-box' : 'incrementer-box-top'}
                      >
                        <Incrementer
                          {...(isWebConfig() && { allowInput: true })}
                          allowNegative={false}
                          data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                          disabled={shouldBeDisabled}
                          maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                          onUpdate={this.onIncrementerChoiceUpdate}
                          quantity={quantity || 0}
                        />
                      </div>
                    ) : null}
                  </div>

                }


              </div>
            </IonItem>


          </div>
        );
      } else {
        return (
          <div
            className={`sub-item ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
          >
            <IonItem lines="none" key={makeKey(choiceIndex, sku, groupIndex)}>
              <div>
                {Basket.isProductUnsnoozed(item) ? (
                  <>
                    {multiSelectionPermitted ? (
                      <IonCheckbox
                        labelPlacement="end"
                        disabled={shouldBeDisabled}

                        color="primary"
                        slot="start"
                        checked={isChecked}
                        onIonChange={(event) => {
                          this.handleInputChange(
                            groupIndex,
                            choiceIndex,
                            multiSelectionPermitted,
                            event,
                          );
                        }}
                      >
                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              <Spacer size={0} />

                              {formatPrice(productPrice) ? <NormalText>+{formatPrice(productPrice)}</NormalText> : null}

                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                          </div>
                        }

                      </IonCheckbox>

                    ) : (
                      <IonRadio
                        labelPlacement="end"
                        slot="start"
                        className="details-radio"
                        color='primary'
                        value={choiceIndex}
                        checked={isChecked}
                      >

                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              <Spacer size={0} />

                              {formatPrice(productPrice) ? <NormalText>+{formatPrice(productPrice)}</NormalText> : null}

                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                          </div>
                        }
                      </IonRadio>

                    )}
                  </>
                ) : (
                  <div className="checkbox-placeholder"></div>
                )}
                {isWebConfig() &&
                  <div className='sub-item-content'>
                    {(getConfig().flags.showModifierImage) &&
                      <div className='modifier-image'>
                        {item?.itemRichData?.squareImageUrl ?
                          <img src={item?.itemRichData?.squareImageUrl.replace(/http:\/\//g, 'https://')} />
                          :
                          <img src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                        }
                      </div>
                    }
                    <div>



                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                        <StrongText>{__(getProductName(item, profile))}</StrongText>
                        {formatPrice(productPrice) ? <NormalText>+{formatPrice(productPrice)}</NormalText> : null}
                      </div>
                      {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                        <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                      }

                      {allergensData && allergensData.length > 0 ? (
                        <SmallText className='primary-color'>
                          {allergensData.map(el => capitalize(el)).join(', ')}
                        </SmallText>
                      ) : null}


                    </div>
                  </div>

                }


              </div>
            </IonItem>


          </div>
        );
      }
    });
    if (multiSelectionPermitted) {
      return <div className="item-details-group-wrapper">{allChoices}</div>;
    } else {
      //radio
      return (
        <div className="item-details-group-wrapper">
          <IonRadioGroup
            allowEmptySelection={true}
            value={
              selectedChoices &&
                selectedChoices[groupIndex] &&
                selectedChoices[groupIndex].length > 0
                ? choices.findIndex((i) => i.sku === selectedChoices[groupIndex][0].sku)
                : -1
            }
            onIonChange={(event) => {
              this.handleInputChange(
                groupIndex,
                event.target.value,
                multiSelectionPermitted,
                event,
              );
            }}
          >
            {allChoices}
          </IonRadioGroup>
        </div>
      );
    }
  };

  drawGroupLabel = (menuGroupItem, groupIndex) => {
    const { validationErrors } = this.state;
    const { __, profile } = this.props;
    let { description, min, max, maximumSelection, minimumSelection, mustSelectAnItem } = menuGroupItem;
    min = Math.max(0, parseInt(min ?? minimumSelection) || 0);
    max = Math.max(0, parseInt(max ?? maximumSelection) || 0);
    if (mustSelectAnItem && min === 0) {
      min = 1;
    }
    let minMaxlabel;
    if (min === 0 && max === 0) {
      minMaxlabel = __('Optional');
    } else if (min === 0 && max === 1) {
      minMaxlabel = __('Optional - choose 1');
    } else if (min === 0 && max >= 2) {
      minMaxlabel = __('Optional - choose up to {max}', { max });
    } else if (min === max) {
      minMaxlabel = min === 1 ? __('Choose {min} option', { min }) : __('Choose {min} options', { min });
    } else if (max === 0) {
      minMaxlabel = min === 1 ? __('Choose at least {min} option', { min }) : __('Choose at least {min} options', { min });
    } else {
      minMaxlabel = __('Choose between {min} and {max} options', { min, max });
    }

    return (
      <>
        <IonItem lines="none" >
          <div style={{ width: '100%' }} tabIndex="-1" >
            <StrongText >{getProductDescription(menuGroupItem, profile).replace(/(<([^>]+)>)/gi, '')}</StrongText>
            <Spacer size={1} />

            <SmallText className={'block field-error'}>
              {isWebConfig() &&
                <IonIcon icon={alertCircle} />
              }
              {minMaxlabel}
            </SmallText>
          </div>
        </IonItem>
      </>
    );
  };

  drawMenuDealGroups = (menuGroupItem, index) => {
    const multiSelectionPermitted = menuGroupItem.multiSelectionPermitted;
    if (isChoicesGroupValid(menuGroupItem) && (
      !getConfig().flags.hasUpsellOnKiosk ||
      menuGroupItem.mustSelectAnItem
    )) {
      if (isDefined(multiSelectionPermitted)) {
        return (
          <div className={`item-details-group ${this.state.validationErrors[index] ? 'group-required' : ''}`} key={index}>
            {this.drawGroupLabel(menuGroupItem, index)}
            {this.drawGroupChoices(menuGroupItem, multiSelectionPermitted, index)}
          </div>
        );
      } else {
        return this.drawGroupLabel(menuGroupItem);
      }
    }
  };

  constructBasketItem = () => {
    const { item } = this.props;
    const { quantity, selectedChoices, instructions } = this.state;
    // const item = item

    return {
      item,
      quantity,
      selectedChoices,
      instructions,
    };
  };

  checkItemForUpsell = (menuDealGroups) => {
    if (menuDealGroups.length > 0 && this.numberOfUnrequiredMenuDeals(menuDealGroups) > 0 && getConfig().flags.hasUpsellOnKiosk) {
      this.setState({ upsellModalOpened: true });
    } else {
      this.addToOrder();
    }
  }
  drawUnrequiredMenuDealGroups = (menuGroupItem, index) => {
    const multiSelectionPermitted = menuGroupItem.multiSelectionPermitted;
    if (isChoicesGroupValid(menuGroupItem) && !menuGroupItem.mustSelectAnItem) {
      if (isDefined(multiSelectionPermitted)) {
        return (
          <div className={`item-details-group ${this.state.validationErrors[index] ? 'group-required' : ''}`} key={index}>
            {this.drawGroupLabel(menuGroupItem, index)}
            {this.drawGroupChoices(menuGroupItem, multiSelectionPermitted, index)}
          </div>
        );
      } else {
        return this.drawGroupLabel(menuGroupItem);
      }
    }
  };

  numberOfUnrequiredMenuDeals = (menuDealGroups = []) => {
    let number = 0;
    menuDealGroups.forEach((menuGroupItem) => {
      if (isChoicesGroupValid(menuGroupItem) && !menuGroupItem.mustSelectAnItem) {
        number++;
      }
    });
    return number;
  }

  addToOrder = () => {
    const newBasketItem = this.constructBasketItem();
    const validationErrors = validateItem(newBasketItem);
    const { item } = this.props;
    if (validationErrors.errorCount > 0) {
      this.setState({ validationErrors: validationErrors.errors }, () => {
        this.setShowValidationAlert(true);
      });
    } else {

      addToBasket(newBasketItem);
      this.props.closeModal();

    }

    let allergensCodes = item.itemRichData
      ? item.itemRichData.allergenCodes
        ? item.itemRichData.allergenCodes
        : []
      : [];
    if (allergensCodes.length > 0) {
      let allergensData = [{ allergens: this.state.allergensCodes }, { sku: item.sku }];
      if (isDefined(newBasketItem.selectedChoices)) {
        newBasketItem.selectedChoices.forEach((group) => {
          group.forEach((item) => {
            if (
              isDefined(item.itemRichData) &&
              isDefined(item.itemRichData.allergenCodes) &&
              item.itemRichData.allergenCodes.length > 0
            ) {
              setAllergen([{ allergens: item.itemRichData.allergenCodes }, { sku: item.sku }]);
            }
          });
        });
      }
      setAllergen(allergensData);
    }
  };
  setShowValidationAlert = (flag) => this.setState({ showValidationAlert: flag });

  scrollToRequiredField = () => {
    const requiredGroups = document.querySelectorAll('.group-required');
    document.querySelectorAll('.group-required').forEach((el) => el.classList.add('with-error'));
    requiredGroups[0].scrollIntoView({ behavior: 'smooth' })

  };
  getShowAddToOrderVisibilityStatus = () => {
    const availableOrderModules = getConfig().delivery.filter((d) => !d.isRemoved && !d.isDisabled && !d.isHiddenFromSidebar);
    const availableOrderModulesHiddenFromSidebar = getConfig().delivery.filter((d) => !d.isRemoved && !d.isDisabled && d.isHiddenFromSidebar);
    if (availableOrderModules.length > 0) {
      return true;
    }
    if (availableOrderModulesHiddenFromSidebar.length > 0) {
      if (isEmptyObject(Basket.getRestaurant())) {
        return false;
      } else {
        return true;
      }
    }
  };
  render() {
    const { __, profile, hideIncrementer, item } = this.props;
    const { quantity, price, showValidationAlert, allergensCodes } = this.state;
    const menuDealGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const isAddToOrderBtnValid = validateItem(this.constructBasketItem()).errorCount === 0;
    const showOrderNowButton = Basket.getOrderType() === 'browse-menu' ? Basket.getRestaurant()?.show_order_now_button : true;
    let showAddToOrder = this.getShowAddToOrderVisibilityStatus(getConfig().delivery);
    return (
      <>
        {allergensCodes.length > 0 &&
          <>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <AllergensIcon fill='var(--okx-box-wrapper-color)' />
                <StrongText>{__('Allergens')}</StrongText>
              </div>
              <Spacer size={0} />
              <StrongText className='block primary-color'>
                {allergensCodes.map(el => capitalize(el)).join(', ')}
              </StrongText>

            </div>
            <Spacer size={3} />
          </>

        }
        <div className="item-details-card-content">
          <IonList className="item-details-card-list">
            {menuDealGroups.map(this.drawMenuDealGroups)}
            {getConfig().flags.specialInstructions.isDisplayed && showOrderNowButton ? (
              <>
                <Spacer size={5} />

                {this.state.instructions === '' ? (
                  <>
                    <IonButton
                      onClick={() => {
                        this.setState({ specialInstructionsModalOpen: true });
                      }}
                      color="secondary"
                      className="link no-borders add-instructions-button capitalized   transparent"
                    >
                      {__('Add special instructions')}
                    </IonButton>
                  </>
                ) : (
                  <>
                    <IonItem lines="none">
                      <Subtitle className="bold label-color special-instructions-title">{__('Special Instructions')}</Subtitle>
                    </IonItem>
                    <div
                      className="box-content special-instructions-wrapper"
                      onClick={() => {
                        this.setState({
                          specialInstructionsModalOpen: true,
                        });
                      }}
                    >
                      <NormalText>{this.state.instructions}</NormalText>


                      <EditIcon className='fill-text' style={{ margin: 0 }} onClick={() => {
                        this.setState({
                          specialInstructionsModalOpen: true,
                        });
                      }} />

                    </div>
                  </>
                )}
                <Modal
                  className='fit-content'
                  onDidDismiss={() => this.setState({ specialInstructionsModalOpen: false })}
                  isOpen={this.state.specialInstructionsModalOpen}
                >
                  <div className='small-padding flex-row-wrapper flex-align-center flex-justify-start text-centered'>
                    <Title className='modal-title block centered' style={{ width: '100%', lineHeight: '1' }}>{__('Special Instructions')}</Title>
                    <Spacer size={2} />
                    <IonItem style={{ width: '100%' }} class="input-field-wrapper" lines="none">
                      <IonTextarea
                        onIonChange={this.instructionsChange}
                        rows={5}
                        placeholder={__('Enter your instructions')}
                        value={this.state.modalInstructions}
                      ></IonTextarea>
                    </IonItem>
                    <Spacer size={5} />
                    <IonButton
                      color="primary"
                      expand="block"
                      className=" large-button"
                      onClick={() => {
                        setTimeout(() => {
                          this.setState({
                            instructions: this.state.modalInstructions,
                            specialInstructionsModalOpen: false,
                          });
                        }, 500);
                      }}
                    >
                      {' '}
                      {__('Save instructions')}
                    </IonButton>
                    <IonButton onClick={() => this.setState({ specialInstructionsModalOpen: false })} color='secondary' expand='block' className='link large-button'>{__('Cancel')}</IonButton>
                  </div>
                </Modal>
              </>
            ) : null}
          </IonList>
        </div>

        {!hideIncrementer && showOrderNowButton ? (
          <>
            {showAddToOrder && (
              <div
                style={{
                  ...(getConfig().frenchDisclaimer?.dashboardDisclaimerImage
                    ? { paddingBottom: '40px' }
                    : null),
                }}
                className="item-details-actions flex-col-wrapper flex-align-center flex-justify-between"
              >
                <Incrementer
                  allowNegative={false}
                  quantity={quantity}
                  onUpdate={this.onIncrementerUpdate}
                  minLimit={1}
                  allowInput={true}
                  large={true}
                />
                <IonButton
                  disabled={quantity < 1}
                  className={`add-to-order-button large-button ${isAddToOrderBtnValid ? '' : 'disabled'}`}
                  expand='block'
                  onClick={() => !isAddToOrderBtnValid ? this.scrollToRequiredField() : this.checkItemForUpsell(menuDealGroups)}
                >
                  <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <Subtitle>{(Basket.getOrderType() === 'browse-menu') || (Basket.itemsCount() === 0 && isEmptyObject(this.props.ikentooMenu))
                      ? __('Start New Order')
                      : __('Add to Order')}</Subtitle>
                    <Subtitle>{price}</Subtitle>
                  </div>

                </IonButton>
                {getConfig().frenchDisclaimer?.dashboardDisclaimerImage && (
                  <div className="dashboard-disclaimer-wrapper">
                    <img src={getConfig().frenchDisclaimer?.dashboardDisclaimerImage}></img>
                  </div>
                )}
              </div>
            )}
          </>
        ) : null}
        <IonAlert
          isOpen={showValidationAlert}
          onDidDismiss={() => this.setShowValidationAlert(false)}
          header={__('Validation')}
          message={__('Please check any required options')}
          buttons={[{ text: __('OK'), role: 'cancel', cssClass: 'secondary' }]}
        />
        <Modal
          isOpen={this.state.upsellModalOpened}
          onDidDismiss={() => this.setState({ upsellModalOpened: false })}
          className={`${isWebConfig() ? 'modal-classic item-details-modal' : ''}`}
        >
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Title >{__('Why not add')}</Title>
            <Spacer size={5} />
            <div className='item-details-card-content' style={{ overflow: 'auto' }}>
              {menuDealGroups.map(this.drawUnrequiredMenuDealGroups)}
            </div>

            <Spacer size={5} />
            <div className='centered'>
              <IonButton
                color="primary"
                expand="block"
                className="large-button"
                onClick={() => {
                  this.setState({ upsellModalOpened: false }, () => {
                    this.addToOrder();

                  });
                }}
              >
                {__('Continue')}
              </IonButton>
              <Spacer size={1} />
              <IonButton
                color={'secondary'} className='large-button'
                onClick={() => {
                  this.setState({ upsellModalOpened: false }, () => {
                    this.addToOrder();

                  });
                }}>

                {__('No thanks')}
              </IonButton>

            </div>
          </div>



        </Modal>
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    profile: store.profile.profile,
    restaurantsUpdated: store.restaurants.restaurantsUpdated,
    basketUpdated: store.orders.basketUpdated,
    allergens: store.restaurants.allergens,
    storedItemWeb: store.orders.storedItemWeb,
    ikentooMenu: store.restaurants.ikentooMenu || {},
    clientProfile: store.common.clientProfile,

  };
};

export const ItemDetailsRaw = connect(mapStateToProps)(withTranslation(itemDetailsContent));

class itemDetails extends Component {
  constructor(props) {
    super(props);
    this.x = React.createRef();
    this.state = {
      nameVisible: true,
      allergens: []
    };
  }
  onContentScrollHandler() {
    if (!this.isScrolledIntoView(this.x.current)) {
      this.setState({ nameVisible: false });
    } else {
      this.setState({ nameVisible: true });
    }
  }
  isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
    return isVisible;
  }
  shouldComponentUpdate(prevProps, prevState) {
    if (this.state.nameVisible !== prevState.nameVisible || this.state.allergens !== prevState.allergens) {
      return true;
    } else {
      return false;
    }
  }
  handleAlergens = (allergens) => {
    this.setState({ allergens })
  }
  render() {
    const { location, __, profile } = this.props;
    const item = location.state;
    const { selectedMenu } = item;
    const { allergens } = this.state
    let image =
      item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
    if (image && image.indexOf('http://') !== -1) {
      image = image.replace(/http:\/\//g, 'https://');
    }
    return (
      <Layout
        headerTitle={__('Item Details')}
        scrollY={false}
        color="transparent"
        noPadding
      >
        <div className="item-details-main-wrapper">
          <div
            className={
              this.state.nameVisible ? ' item-details-header' : 'active item-details-header'
            }
          >
            <div className="item-details-back">
              <IonButton
                className="solo-button"
                color="white"
                onClick={() => forwardTo('/order', { selectedMenu })}
              >
                <IonIcon slot="icon-only" icon={chevronBackOutline} />
              </IonButton>
            </div>
            <div
              style={{
                transition: !this.state.nameVisible ? 'transform 0.3s ease-in-out' : 'none',
                display: 'flex',
                alignItems: 'center',
                marginLeft: '20px',
                transform: this.state.nameVisible ? 'translateY(-300px)' : 'translateY(0)',
              }}
            >
              <Subtitle >
                {__(getProductName(item, profile))}
              </Subtitle>
            </div>
          </div>
          <div
            className="scrollable-y item-detals-background"
            onScroll={() => {
              this.onContentScrollHandler();
            }}
          >
            <div className="item-details-info">
              {image && image !== '' ? (
                <div className="item-details-img">
                  <img alt="item details" src={image} />
                </div>
              ) : (
                <div className="item-details-img">
                  <img style={{ objectFit: 'contain' }} alt="item details" src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                </div>
              )}
              <div className="item-details-name" ref={this.x}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 'var(--spacer-2)' }}>
                  <Title>{__(getProductName(item, profile))}</Title>
                  {(!getConfig()?.stamp_earning_skus?.includes(item.sku) && parseFloat(item.productPrice) > 0) &&
                    <Title>{formatPrice(item.productPrice)}</Title>
                  }
                </div>
                {getProductDescription(item, profile) !== '' &&
                  <>
                    <Spacer size={2} />
                    <NormalText
                      className="item-details-card-description"
                      dangerouslySetInnerHTML={{
                        __html: getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
                      }}
                    ></NormalText>                </>
                }
                {allergens.length > 0 ? (
                  <>
                    <Spacer size={2} />
                    <SmallText className='primary-color'>
                      {allergens.map(el => capitalize(el)).join(', ')}
                    </SmallText>
                  </>
                ) : null}
              </div>
              {getConfig()?.stamp_earning_skus?.includes(item.sku) &&
                <>
                  <Spacer size={4} />
                  <div style={{ padding: '0 var(--ion-padding) 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className='product-has-stamp-earned'>
                      {getConfig()?.stamp_earning_skus?.includes(item.sku) &&
                        <>
                          <DiscountIcon />
                          <SmallText>{__('Earns loyalty stamps')}</SmallText>
                        </>
                      }
                    </div>
                    <div className="item-details-price">
                      <Subtitle>{formatPrice(item.productPrice)}</Subtitle>
                    </div>
                  </div>
                </>
              }
            </div>
            <Spacer size={5} />
            <ItemDetailsRaw handleAlergens={this.handleAlergens} item={item} profile={profile} />
          </div>
        </div>
      </Layout>
    );
  }
}

const stateToProps = (store) => {
  return {
    profile: store.profile.profile,
    clientProfile: store.common.clientProfile,
  };
};

export default connect(stateToProps)(withTranslation(itemDetails));
